var map = {
	"./article_annotation.svg": 94108,
	"./article_content.svg": 1954,
	"./article_drawing.svg": 12835,
	"./article_layout.svg": 91641,
	"./article_online.svg": 35338,
	"./article_onlinephotos.svg": 47309,
	"./article_proofread.svg": 42511,
	"./article_publish.svg": 28332,
	"./article_resource.svg": 76219,
	"./article_sign.svg": 72080,
	"./article_translate.svg": 90139,
	"./article_widgets.svg": 37290,
	"./home.svg": 51387,
	"./home_search.svg": 50062,
	"./left-all.svg": 86195,
	"./left.svg": 65433,
	"./right-all.svg": 65226,
	"./right.svg": 82788,
	"./task.svg": 30993,
	"./tip.svg": 78429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3777;